import { brakefluidAuthorisedService } from '../../helpers/services/brakefluidAuthorised.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const AUTHORISED_MODULE = 'brakefluidAuthorised'; 

// define action 
export const GET_ALL_AUTHORISEDS = 'getAllAuthoriseds';
export const GET_AUTHORISED = 'getAuthorised';
export const UPDATE_AUTHORISED = 'updateAuthorised';
export const CREATE_AUTHORISED = 'createAuthorised';
export const UPDATE_AUTHORISED_STATUS = 'updateAuthorisedStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_AUTHORISED_REQUEST = "getAllAuthoriseds";
const GET_AUTHORISED_REQUEST = "getAuthorised";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_AUTHORISEDS]({ commit }, { filter }) {
        brakefluidAuthorisedService
            .getAllAuthoriseds(filter)
            .then(
                (result) => {
                    commit(GET_ALL_AUTHORISED_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_AUTHORISED]({ commit }, { id }) {
        brakefluidAuthorisedService
            .getAuthorised(id)
            .then(
                (result) => {
                    commit(GET_AUTHORISED_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_AUTHORISED]({ commit }, { data }) {
        commit(REQUEST)
        brakefluidAuthorisedService
            .updateAuthorised(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.authorised')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_AUTHORISED]({ commit }, { data }) {
        commit(REQUEST)
        brakefluidAuthorisedService
            .createAuthorised(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.authorised')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_AUTHORISED_STATUS]({ dispatch }, { filter, data }) {
        brakefluidAuthorisedService
            .updateAuthorisedStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_AUTHORISEDS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Brake-fluid-authorised-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_AUTHORISED_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_AUTHORISED_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


